module.exports = __webpack_public_path__ + "static/media/insulinresistance-Figure6.c221f7a6.jpg";